module.exports = __webpack_public_path__ + "img/android.9178ad6e.svg";